<template>
  <section>
    <section class="viewport"
             v-bind:class="getViewportSectionCount()">
      <section
        v-for="(section, index) in sections"
        v-bind:key="index"
      >
        <section v-if="sections.length > 1">
        <!-- add name in the center only for subcategories-->
          <h3 class="folder-section__sub-heading">
          <span>
            <span
              class="folder-section__sub-heading__arrow"
              v-on:click="removeSection">
              <img src="../../assets/images/arrow-left.svg" alt="Up"/>
            </span>
          </span>
            {{section.name}}
          </h3>
        </section>
        <section>
            <ux-folder-header
              class="folder__heading"
              v-for="folder in section.folders"
              v-bind:key="folder.id"
              v-bind:name="folder.name"
              v-bind:total-files="folder.content.totalFiles"
              v-bind:total-folders="folder.content.totalFolders"
              v-bind:last-updated="folder.lastUpdated.date"
              v-on:open-container="onOpenContainer(folder)"></ux-folder-header>
            <div
              class="text-center"
              v-if="hasNetworkError">
              <p>An error has occurred.</p>
              <p>
                <button
                  class="folder__load-more"
                  @click="onOpenContainer(folder)">Reload</button>
              </p>
            </div>
        </section>
        <section
          class="folder__content folder__content__files"
          v-if="section.files && section.content && section.content.filesType === 'document'">
          <ux-folder-file-document
            v-bind:file="file"
            v-for="file in section.files"
            v-bind:key="file.id"
          >
          </ux-folder-file-document>
        </section>
        <section
          class="row folder__content folder__content__files folder__content__files--images"
          v-if="section.files && section.files.length && section.content && section.content.filesType === 'image'">
          <ux-folder-file-image
            v-bind:file="file"
            v-for="(file, index) in section.files"
            v-bind:index="index"
            v-bind:key="file.id"
            v-on:open-gallery="onOpenGallery(index, section.files)"></ux-folder-file-image>
        </section>
        <!--TODO: Hardcoded, please substitute file types for production-->
        <section
          class="folder__content folder__content__files folder__content__files--questions"
          v-if="section.files && section.files.length && section.content && section.content.filesType === 'image'">
        </section>
        <div class="loader" v-if="section.isLoading">
          <img src="../../assets/images/loading-spinner.svg" alt="Loading...">
        </div>
        <p class="text-center" v-if="total > page * pageSize">
          <button class="folder__load-more"
            v-on:click="loadMore(section)">Load more</button>
        </p>
      </section>
    </section>
  </section>
</template>

<script>
  import config from '../../config'
  const imagePageSize = 12;
  const pageSize = 10;

  export default {
    name: 'UXSmallFormFactorFolderContentContainer',
    data() {
      return {
        sections: [this.folderStructure],
        name: '',
        pageSize: 10,
        page: 1,
        total: 0,
        hasNetworkError: false,
        folder: {}
      }
    },
    props: {
      folderStructure: Object,
      size: {
        type: String,
        validator(value) {
          return ['md', 'lg'].includes(value);
        }
      }
    },
    methods: {
      resetPagination() {
        this.page = 1;
        this.total = 0;
      },
      onOpenContainer(folder) {
        if (folder) {
          this.folder = folder;
        }
        //scroll the container into view
        var rect = document.getElementsByClassName('folder-section')[0].getBoundingClientRect();
        if (rect.top + 60 < 0) {
          window.scrollTo(0, window.scrollY + rect.top - 60); //60 is the height of the header in mobile
        }

        this.resetPagination();
        if (this.folder && this.folder.content && this.folder.content.filesType === 'image') {
          this.pageSize = imagePageSize;
        } else {
          this.pageSize = pageSize;
        }
        if (!this.folder.isLoaded || this.hasNetworkError) {
          this.folder.isLoading = true;
          if (!this.hasNetworkError) {
            //if it has been a network error
            //the section container is already pushed to the viewport
            this.sections.push(folder);
          }
          this.load(this.folder, () => {
            this.folder.isLoaded = true;
            this.folder.isLoading = false;
            this.hasNetworkError = false;
            if (this.folder.pagination) {
              this.total = this.folder.pagination.total;
              this.page = this.folder.pagination.page;
            }
            setTimeout(() => {
              this.sections.splice(-1, this.folder);
            }, 300);
          }, () => {
            console.log();
            this.folder.isLoading = false;
            this.hasNetworkError = true;
          });
        } else {
          setTimeout(() => {
            this.sections.push(this.folder);
          }, 300)
        }
      },
      onOpenGallery(index, images) {
        //TODO (Marta): Replace thumbnailUrl with the preview url
        this.images = images.map(image => Object.assign(image, { href: config.baseUrl + image.previewUrl }));
        this.$root.$emit('pass-images-and-index', this.images, index);
      },
      removeSection() {
        this.sections.pop();
        this.resetPagination();
      },
      getViewportSectionCount() {
        return `viewport--${this.sections.length}-section-container`;
      },
      loadMore(section) {
        section.isLoading = true;
        ++this.page;
        this.load(section, () => {
          section.isLoading = false;
          this.sections.splice();
        })
      },
      load(folder, cb, err) {
        //use $root.$emit as $emit only works with child - parent and we can have folder inside a folder
        this.$root.$emit('load-data', folder.id, folder.groupId, this.pageSize, this.page, folder, cb, err);
      }
    },
    watch: {
      folderStructure(newValue) {
        this.sections = [newValue];
      }
    }
  }
</script>
